import { Target } from 'lucide-react'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router'
import {
	CommitmentMatrixPeriodFilter,
	defaultPeriodFilterValue,
	type PeriodFilterValue,
} from '@/components/administration/commitment-matrix/commitment-matrix-period-filter'
import {
	ALL_SCOPE,
	CommitmentMatrixScopeFilter,
	type MatrixScope,
} from '@/components/administration/commitment-matrix/commitment-matrix-scope-filter'
import { CommitmentMatrixDashboard } from '@/components/administration/commitment-matrix/dashboard'
import { AdminCardPage } from '@/components/commons'
import { ROUTES } from '@/constants/routes'

export const CommitmentMatrixDashboardPage = () => {
	const navigate = useNavigate()

	const [scope, setScope] = useState<MatrixScope>(ALL_SCOPE)
	const [period, setPeriod] = useState<PeriodFilterValue>(
		defaultPeriodFilterValue(),
	)

	const scopeLabel = useMemo(() => {
		if (scope.crIds.length === 0 && scope.branchIds.length === 0) return null
		return scope.crIds.length > 0
			? scope.crIds.length > 1
				? 'CRs selecionados'
				: 'CR selecionado'
			: scope.branchIds.length > 1
				? 'Filiais selecionadas'
				: 'Filial selecionada'
	}, [scope])

	return (
		<AdminCardPage
			icon={<Target className="size-5" />}
			title="Matriz de Comprometimento"
			subtitle="Acompanhe o cumprimento da equipe em relação às metas de inspeção."
			onBack={() => navigate(ROUTES.DASHBOARD.HOME)}
		>
			<div className="flex flex-col gap-2">
				<CommitmentMatrixScopeFilter scope={scope} onChange={setScope} />
				<CommitmentMatrixPeriodFilter value={period} onChange={setPeriod} />
			</div>

			{scopeLabel && (
				<p className="-mt-1 text-xs text-kaefer-medium-grey">
					Exibindo dados filtrados por <strong>{scopeLabel}</strong>.
				</p>
			)}

			<CommitmentMatrixDashboard
				branchIds={scope.branchIds}
				crIds={scope.crIds}
				jobGroupClusterId={scope.jobGroupClusterId ?? undefined}
				jobGroupId={scope.jobGroupId ?? undefined}
				range={period.range}
			/>
		</AdminCardPage>
	)
}
